import { getHrefParam } from '@store/ultile';

/** PNS 韩国 OneStore 包（gameId 227）迁回 37games 合规 */
export const PNS_KR_ONESTORE_GAME_ID = 227;
export const PNS_KR_ONESTORE_PACKAGE = 'com.global.krztmslg.onestore';
export const PNS_KR_ONESTORE_SERVICE_TERMS_URL =
  'https://gpassport.37games.com/center/ServicePrivacy/service';
export const PNS_KR_ONESTORE_PRIVACY_TERMS_URL =
  'https://gpassport.37games.com/center/ServicePrivacy/privacy';

export function isPnsKrOnestorePackage() {
  return getHrefParam('packageName') === PNS_KR_ONESTORE_PACKAGE;
}

/** 用户中心条款外跳 37games（需同时满足 gameId + 包体） */
export function isPnsKrOnestoreUserCenterTerms(gameId) {
  return +gameId === PNS_KR_ONESTORE_GAME_ID && isPnsKrOnestorePackage();
}

export function replaceKrTermsDetailFor37Games(detail) {
  if (!detail) return detail;
  const gamesUrl = window.atob('aHR0cHM6Ly93d3cuMzdnYW1lcy5jb20v');
  const supportEmail = window.atob('Z2xvYmFsLnN1cHBvcnRAMzdnYW1lcy5jb20=');
  const brandName = window.atob('MzdHQU1FUw==');
  return detail
    .replace(/https:\/\/www\.blancozone\.com\//g, gamesUrl)
    .replace(/global\.support@blancozone\.com/gi, supportEmail)
    .replace(/service@Blancozone\.com/gi, supportEmail)
    .replace(/BLANCOZONE NETWORK CO\., LIMITED/g, brandName)
    .replace(/BLANCOZONE/g, brandName)
    .replace(/Blancozone/g, brandName);
}
